export default async function slink ({ to, store }) {
  // First, check for to.params.slink because it might be set during routing (e.g. from SSO redirect)
  const slink = to.params.slink || store.state.slink || localStorage?.getItem('slink')
  if (!slink) {
    if (to.name === 'login-select-school') return
    return { name: 'login-select-school' }
  }

  if (!store.state.slink) {
    await store.dispatch('SET_SLINK', slink)
  }

  if (to.params.slink === slink) return
  return { ...to, params: { slink, ...to.params } }
}
